import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessCreatedVsResolvedRoute: InvariantJiraRoute = {
	name: 'classic-business-reports-created-vs-resolved',
	path: '/jira/core/projects/:projectKey/reports/created-vs-resolved',
};
